import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  resize () {
    this.element.style.height = ''
    this.element.style.height = this.element.scrollHeight + 'px'
  }
}
